function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Descriptions, Divider, Radio, notification } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var AddConclusion = function AddConclusion(_ref) {
  var candidat = _ref.candidat,
    handler = _ref.handler;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormProcessing = _useState2[0],
    setIsFormProcessing = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    conclusionItems = _useState4[0],
    setConclusionItems = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formError = _useState6[0],
    setFormError = _useState6[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var conclusionItemsVa = [{
    value: 1,
    label: "Apte"
  }, {
    value: 2,
    label: "A. (aménagement)"
  }, {
    value: 3,
    label: "A. (restriction)"
  }, {
    value: 7,
    label: "A. reserve (consultion)"
  }, {
    value: 4,
    label: "I. temp."
  }, {
    value: 5,
    label: "I. déf. (reclassement)"
  }, {
    value: 6,
    label: "I. déf"
  }];
  var conclusionItemsPe = [{
    value: 8,
    label: "Apte"
  }, {
    value: 9,
    label: "A. (aménagement)"
  }, {
    value: 10,
    label: "A. (restriction)"
  }, {
    value: 11,
    label: "A. sous reserve (consultation)"
  }, {
    value: 12,
    label: "I. temp."
  }, {
    value: 13,
    label: "I. déf. (reclassement)"
  }, {
    value: 14,
    label: "I. déf."
  }];
  var onFinish = function onFinish(values) {
    setIsFormProcessing(true);
    var formData = new FormData();
    formData.append("motif", candidat.reason);
    formData.append("conclusion", values.conclusion);
    formData.append("comment", values.comment);
    formData.append('customer_id', candidat.id);
    formData.append("prevention_tips", values.prevention_tips);
    formData.append("mr_general_state", values.mr_general_state);
    formData.append("mr_conclusion", values.mr_conclusion);
    formData.append("mr_recommandation", values.mr_recommandation);
    formData.append("user_id", Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'addconclusion', formData).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError('Une erreur est survenue');
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  useEffect(function () {
    form.setFieldsValue({
      comment: "NEANT",
      prevention_tips: "",
      mr_recommandation: "",
      mr_conclusion: "Patient(e) vu(e) ce jour avec un bon état de santé.",
      mr_general_state: "Etat général satisfaisant"
    });
    if (candidat.motif == 0) setConclusionItems(conclusionItemsVa);
    if (candidat.motif == 1) setConclusionItems(conclusionItemsPe);
    if (candidat.motif != 0 && candidat.motif != 1) setConclusionItems(conclusionItemsVa);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        padding: "10px",
        background: "#D8CFCF",
        borderRadius: "0px 7px 7px 7px",
        color: "#FFFFFF"
      },
      children: /*#__PURE__*/_jsxs(Descriptions, {
        title: /*#__PURE__*/_jsx("b", {
          children: "INFOS CANDIDATS"
        }),
        column: 2,
        children: [/*#__PURE__*/_jsx(Descriptions.Item, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Nom complet"
          }),
          children: candidat.name
        }), /*#__PURE__*/_jsx(Descriptions.Item, {
          label: /*#__PURE__*/_jsx("b", {
            children: "T\xE9l\xE9phone"
          }),
          children: candidat.mobile_first
        }), /*#__PURE__*/_jsx(Descriptions.Item, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Poste"
          }),
          children: candidat.job
        }), /*#__PURE__*/_jsx(Descriptions.Item, {
          label: /*#__PURE__*/_jsx("b", {
            children: "Nationalit\xE9"
          }),
          children: candidat.nationality
        }), /*#__PURE__*/_jsx(Descriptions.Item, {
          label: /*#__PURE__*/_jsx("b", {
            children: "SOCIETE"
          }),
          children: candidat.company.label
        })]
      })
    }), /*#__PURE__*/_jsx(Divider, {
      children: "DONNEES DE CONCLUSION"
    }), /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 9,
          md: 10,
          sm: 11,
          children: /*#__PURE__*/_jsxs(Form, {
            layout: "vertical",
            form: form,
            onFinish: onFinish,
            children: [/*#__PURE__*/_jsx(Form.Item, {
              size: "small",
              name: "conclusion",
              label: "Aptitude",
              rules: [{
                required: true,
                message: "Ce champ est obligatoire"
              }],
              children: /*#__PURE__*/_jsx(Radio.Group, {
                options: candidat.reason == 0 || candidat.reason == 2 ? conclusionItemsVa : conclusionItemsPe,
                buttonStyle: "solid",
                optionType: "button"
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "comment",
              label: "Pr\xE9cision",
              children: /*#__PURE__*/_jsx(Input, {})
            }), /*#__PURE__*/_jsx(Divider, {
              children: "DONNEES DU RAPPORT MEDICAL"
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "mr_general_state",
              label: "Etat g\xE9n\xE9ral",
              children: /*#__PURE__*/_jsx(Input, {})
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "mr_conclusion",
              label: "Conclusion",
              children: /*#__PURE__*/_jsx(TextArea, {
                autoSize: true
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              name: "mr_recommandation",
              label: "Recommandations",
              children: /*#__PURE__*/_jsx(TextArea, {
                autoSize: true
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              children: /*#__PURE__*/_jsx(Button, {
                loading: isFormProcessing,
                type: "primary",
                htmlType: "submit",
                children: /*#__PURE__*/_jsx("b", {
                  children: "VALIDER"
                })
              })
            })]
          })
        })
      })
    })]
  });
};
export default AddConclusion;